module.exports = __webpack_public_path__ + "static/img/carpenter_logo_shape_large.3819f05b.png";